import { render, staticRenderFns } from "./KeyValueTextare.vue?vue&type=template&id=5f289e7c&"
import script from "./KeyValueTextare.vue?vue&type=script&lang=js&"
export * from "./KeyValueTextare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports